<style lang="less" scoped></style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.logBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex" style="justify-content:space-between;">
        <div class="left-page-title-div flex-1">更新记录</div>
        <div class="left-page-title-div"> <button class="common-empty-button" @click="resetForm">取 消</button></div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="
            (sels) => {
              selections = sels;
            }
          "
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="createdByName"
            label="更新人"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdWhen"
            label="更新时间"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="address" label="更新内容" align="center">
            <template slot-scope="scope">
               <span v-html="scope.row.oldData"></span>
               <span v-html="scope.row.newData"></span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" size="small"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="list-pagination">
          <ZD-pagination
            :pagination="pagination"
            v-on:pageUpdate="getListData"
          ></ZD-pagination>
        </div>
      </div>

      <div class=" flex-r-end">
        <!-- <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
        <button class="common-empty-button" @click="resetForm">取 消</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig,
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
    };
  },
  created() {
    this.init();
  },
  methods: {
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
     //获取数据
     init() {
      this.getListData(this.pagination, true);
    },
    
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.queryInfo.couponNo = _.$route.query.couponNo;
      _.$H.post(_, _.$A.coupon.getEidtHistory, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },

    // 取消
    resetForm() {
      this.detailForm = {};
      this.$router.push({
        name: pageConfig.listRouter,
      });
    },
  },
};
</script>
